export default "__VITE_ASSET__M2FlXgNR__"